<div class="card">
    <div class="card-body">
        <h5 class="card-title">{{ 'export.events.cardTitle' | transloco }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'export.selectExportTypeBelow' | transloco }}</h6>

        <hr />

        <mat-checkbox color="primary" name="includeMois" [(ngModel)]="includeChecked"
            >{{ 'export.includeClosedMoisCheckbox' | transloco }}</mat-checkbox
        >

        <hr />

        @if (permService.permissions.HasEventExportAccess) {
            <button class="btn btn-default me-2 mb-2" (click)="downloadEvent(ExportType.Events)">
                {{ 'export.events.eventsButton' | transloco }}
            </button>
            <button class="btn btn-default me-2 mb-2" (click)="downloadEvent(ExportType.EventsAll)">
                {{ 'export.events.eventsMoisActionsButton' | transloco }}
            </button>
            <button
                class="btn btn-default me-2 mb-2"
                (click)="downloadEvent(ExportType.DataBreachesAndMoi)"
            >
                {{ 'export.events.dataBreachMoisButton' | transloco }}
            </button>
            <button
                class="btn btn-default me-2 mb-2"
                (click)="downloadEvent(ExportType.EventEmailNotifications)"
            >
                {{ 'export.events.controlDesignEmailButton' | transloco }}
            </button>
            <button class="btn btn-default me-2 mb-2" (click)="exportEventsRisksAndControls()">
                {{ 'export.events.eventsWithRisksControlsButton' | transloco }}
            </button>
        }
    </div>
</div>
